import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import Row from 'react-bootstrap/Row';
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Table from 'react-bootstrap/Table';
import Button from "react-bootstrap/Button";
import { Container } from "react-bootstrap";
// ************** Datatable
import 'datatables.net-dt/css/dataTables.dataTables.css';  // Estilos de DataTable
import 'datatables.net';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import 'bootstrap-icons/font/bootstrap-icons.css';

import Modal from 'react-bootstrap/Modal';
import Spinner from "react-bootstrap/Spinner";

const TareasCRUD = ({usuario, apiUrl}) => {
    // ****** Definiciones de variables
    const dateFechaActual = new Date();
    //dateFechaActual.setHours(0, 0, 0, 0);
    // Variables de selección
    const [idTareaSelected, setIdTareaSelected] = useState(0);
    const [idEtapaSelected, setIdEtapaSelected] = useState(0);
    const [nombreEtapaSelected, setNombreEtapaSelected] = useState('');
    const [descripcionSelected, setDescripcionSelected] = useState('');
    const [inicioSelected, setInicioSelected] = useState('');
    const [finSelected, setFinSelected] = useState('');
    const [estatusSelected, setEstatusSelected] = useState('');
    const [idUsuarioResponsableSelected, setIdUsuarioResponsableSelected] = useState(0);
    const [nombreUsuarioResponsableSelected, setNombreUsuarioResponsableSelected] = useState('');
    const [idProyectoSelected, setIdProyectoSelected] = useState(0);
    const [fechaInicioEtapa, setFechaInicioEtapa] = useState(dateFechaActual);
    const [fechaFinEtapa, setFechaFinEtapa] = useState(dateFechaActual);
    // Variables para mostrar modales
    const [showModal, setShowModal] = useState(false);
    const [showModalDetalle, setShowModalDetalle] = useState(false);
    const [showModalEliminar, setShowModalEliminar] = useState(false);
    // Variables para listado
    const [tareas, setTareas] = useState([]);
    const [etapas, setEtapas] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [proyectos, setProyectos] = useState([]);
    // ******** Definición de funciones
    // Funciones para los modales
    const handleShowModalDetalle = (IDTAREA, NOMBREETAPA, DESCRIPCION, FECHAINICIO, FECHAFIN, ESTATUS, NOMBREUSUARIO) => {
        setIdTareaSelected(IDTAREA)
        setNombreEtapaSelected(NOMBREETAPA)
        setDescripcionSelected(DESCRIPCION)
        setInicioSelected(FECHAINICIO)
        setFinSelected(FECHAFIN)
        setEstatusSelected(ESTATUS)
        setNombreUsuarioResponsableSelected(NOMBREUSUARIO)
        setShowModalDetalle(true);
    }
    const handleCloseModalDetalle = () => {
        setShowModalDetalle(false);
    }
    //
    const handleShowModal = (IDTAREA, IDETAPA, IDPROYECTO, DESCRIPCION, FECHAINICIO, FECHAFIN, ESTATUS, IDUSUARIORESPONSABLE) => {
        setIdTareaSelected(IDTAREA)
        setIdEtapaSelected(IDETAPA)
        setIdProyectoSelected(IDPROYECTO)
        setDescripcionSelected(DESCRIPCION)
        setInicioSelected(FECHAINICIO)
        setFinSelected(FECHAFIN)
        setEstatusSelected(ESTATUS)
        setIdUsuarioResponsableSelected(IDUSUARIORESPONSABLE)
        setShowModal(true);
    }
    const handleCloseModal = () => {
        setShowModal(false);
    }
    //
    const handleShowModalEliminar = (IDTAREA, NOMBREETAPA, DESCRIPCION, FECHAINICIO, FECHAFIN, ESTATUS, NOMBREUSUARIO) => {
        setIdTareaSelected(IDTAREA)
        setNombreEtapaSelected(NOMBREETAPA)
        setDescripcionSelected(DESCRIPCION)
        setInicioSelected(FECHAINICIO)
        setFinSelected(FECHAFIN)
        setEstatusSelected(ESTATUS)
        setNombreUsuarioResponsableSelected(NOMBREUSUARIO)
        setShowModalEliminar(true);
    }
    const handleCloseModalEliminar = () => {
        setShowModalEliminar(false);
    }
    // Funciones para traer datos
    const obtenerTareas = ()=>{
        axios.post(`${apiUrl}/tarea/obtenTodasTareas?token=${sessionStorage.getItem('token')}`, {})
            .then((objResponse) => {
                setTareas(objResponse.data.response)
            })
            .catch((error) => {
                alert('hubo un error en la obtención de tareas: ' + error.response.data)
            });
    }
    const obtenerUsuarios = () => {
        axios.post(`${apiUrl}/usuario/obtenUsuarios?token=${sessionStorage.getItem('token')}`, {})
            .then((objResponse)=>{
                setUsuarios(objResponse.data.response);
            })
            .catch((error)=>{
                alert('hubo un error en la obtención de usuarios: ' + error.response.data)
            })
    }
    const obtenerEtapas = ()=>{
        axios.post(`${apiUrl}/etapa/obtenEtapasProyecto?token=${sessionStorage.getItem('token')}`, 
            {
                idProyecto: idProyectoSelected
            })
            .then((objResponse) => {
                setEtapas(objResponse.data.response)
            })
            .catch((error) => {
                alert('hubo un error obteniendo las etapas: ' + error.response.data)
            });
    }
    const obtenerProyectos = () => {
        axios.post(`${apiUrl}/proyecto/obtenProyectos?token=${sessionStorage.getItem('token')}`, {})
            .then((objResponse) => {
                setProyectos(objResponse.data.response)
            })
            .catch((error) => {
                alert('hubo un error obteniendo los proyectos: ' + error.response.data)
            });
    }
    useEffect(()=>{
        if(idProyectoSelected !== null && idProyectoSelected !== 0) {
            obtenerEtapas();
        }
    },[idProyectoSelected])
    // Funciones para guardar
    const guardarTarea = () => {
        axios.post(`${apiUrl}/tarea/guardarTarea?token=${sessionStorage.getItem('token')}`, 
            {
                IDTAREA: idTareaSelected, 
                IDETAPA: idEtapaSelected,
                DESCRIPCION: descripcionSelected, 
                INICIO: inicioSelected, 
                FIN: finSelected,
                ESTATUS: estatusSelected, 
                IDUSUARIORESPONSABLE: idUsuarioResponsableSelected,
                IDUSUARIOMODIFICACION: usuario.IDUSUARIO
            })
            .then((objResponse)=>{
                handleCloseModal()
                obtenerTareas()
            })
            .catch((error)=>{
                alert('hubo un error en el guardado de etapa: ' + error.response.data)
            })
    }
    // Eliminar
    const eliminaTarea = () => {
        axios.post(`${apiUrl}/tarea/eliminarTarea?token=${sessionStorage.getItem('token')}`, 
            {
                IDTAREA: idTareaSelected,
                IDUSUARIOELIMINACION: usuario.IDUSUARIO
            })
            .then((objResponse)=>{
                handleCloseModalEliminar()
                obtenerTareas()
            })
            .catch((error)=>{
                alert('hubo un error eliminando la etapa: ' + error.response.data)
            })
    }
    // 
    useEffect(()=>{
        obtenerTareas();
        obtenerUsuarios();
        obtenerProyectos();
    },[])
    //
    Date.prototype.addDays = function(days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
    }

    const columns = [
        { data: 'IDTAREA', with: "10%"},
        { data: 'IDETAPA', visible: false},
        { data: 'IDPROYECTO', visible: false},
        { data: 'NOMBREETAPA', with: "10%"},
        { data: 'DESCRIPCION' },
        { data: 'FECHAINICIO', with: "10%", visible: false},
        { data: 'FECHAFIN', with: "10%", visible: false},
        { data: 'ESTATUS'},
        { data: 'IDUSUARIORESPONSABLE', visible: false}, //
        { data: 'NOMBREUSUARIORESPONSABLE'}, //visible: false
        { title: 'Opciones', with: "10%"},
    ];

    const languageOpt = {
        info: 'Mostrando página _PAGE_ de _PAGES_ (total de _MAX_ encontrados)',
        infoFiltered: '(filtrados de un total de _MAX_ encontrados)',
        lengthMenu: 'Mostrando _MENU_ registros por página',
        zeroRecords: 'Cero colaboradores encontrados con los filtros seleccionados',
        search: 'Buscar',
        infoEmpty: 'No se encontraron',
        emptyTable: 'Tabla vacía (sin registros)'
    }
    
    const options = {
        order: [[0, 'desc']], // Indica que la primera columna (índice 0) se ordene de manera descendente
        columnsDefs: [
            {
                //targets: 1, // Índice de la columna a la que le queremos dar ancho
                //width: '100%' // El ancho deseado para esa columna
            },
            {
                //targets: [9],
                //width: '100px',
            }
        ],
        language: languageOpt,
        responsive: true
    };

    return(
        <div>
            {/* 
                Modal para detalle de etapa
            */}
            <Modal show={showModalDetalle} onHide={handleCloseModalDetalle} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Detalle tarea
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table striped hover responsive size="sm" style={{fontSize: '1em'}}>
                        <tbody>
                            <tr>
                                <td width="50%">idTarea</td>
                                <td width="50%">{idTareaSelected}</td>
                            </tr>
                            <tr>
                                <td>Etapa</td>
                                <td>{nombreEtapaSelected}</td>
                            </tr>
                            <tr>
                                <td>Nombre tarea (Descripción)</td>
                                <td>{descripcionSelected}</td>
                            </tr>
                            <tr>
                                <td>Fecha inicio</td>
                                <td>{inicioSelected}</td>
                            </tr>
                            <tr>
                                <td>Fecha fin</td>
                                <td>{finSelected}</td>
                            </tr>
                            <tr>
                                <td>Estatus</td>
                                <td>{estatusSelected}</td>
                            </tr>
                            <tr>
                                <td>Usuario Responsable</td>
                                <td>{nombreUsuarioResponsableSelected}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModalDetalle}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* 
                Modal para crear/actualizar de tarea
            */}
            <Modal show={showModal} onHide={handleCloseModal} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Actualizar tarea
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table striped hover responsive>
                        <tbody>
                            <tr>
                                <td width="50%">idTarea</td>
                                <td width="50%">{idTareaSelected}</td>
                            </tr>
                            <tr>
                                <td width="50%">Proyecto</td>
                                <td width="50%">
                                    <Form.Select
                                        value={idProyectoSelected}
                                        onChange={(event)=>{
                                            setIdProyectoSelected(event.target.value)
                                        }}
                                    >
                                        <option key="">--- Escoge un proyecto ---</option>
                                        {
                                            proyectos.map(proyecto=>
                                                <option 
                                                    key={'opt_proyecto'+proyecto.IDPROYECTO} 
                                                    value={proyecto.IDPROYECTO}
                                                >
                                                    {proyecto.NOMBREPROYECTO}
                                                </option>
                                            )
                                        }
                                    </Form.Select>
                                </td>
                            </tr>
                            <tr>
                                <td width="50%">Etapa</td>
                                <td width="50%">
                                    <Form.Select
                                        value={idEtapaSelected}
                                        onChange={(event)=>{
                                            const selectedOption = event.target.selectedOptions[0];
                                            const fecha_inicio = selectedOption.dataset.fecha_inicio;
                                            const fecha_fin = selectedOption.dataset.fecha_fin;
                                            setIdEtapaSelected(event.target.value)
                                            setFechaInicioEtapa(fecha_inicio.substring(0, 10))
                                            setFechaFinEtapa(fecha_fin.substring(0, 10))
                                        }}
                                    >
                                        <option key="">--- Escoge la etapa ---</option>
                                        {
                                            etapas.map(etapa=>
                                                <option 
                                                    key={'opt_etapa'+etapa.IDETAPA} 
                                                    value={etapa.IDETAPA}
                                                    data-fecha_inicio={etapa.INICIO}
                                                    data-fecha_fin={etapa.FIN}
                                                >
                                                    {etapa.DESCRIPCION}
                                                </option>
                                            )
                                        }
                                    </Form.Select>
                                </td>
                            </tr>
                            <tr>
                                <td>Nombre tarea</td>
                                <td>
                                    <Form.Control value={descripcionSelected} onChange={(event)=>{ setDescripcionSelected(event.target.value) }}></Form.Control>
                                </td>
                            </tr>
                            <tr>
                                <td>Fecha inicio</td>
                                <td>
                                    <Form.Control 
                                        type="date"
                                        value={inicioSelected}
                                        onChange={(event)=>{ setInicioSelected(event.target.value) }}
                                        min={fechaInicioEtapa}
                                        max={fechaFinEtapa}
                                    ></Form.Control>
                                </td>
                            </tr>
                            <tr>
                                <td>Fecha fin</td>
                                <td>
                                    <Form.Control 
                                        type="date"
                                        value={finSelected}
                                        onChange={(event)=>{ setFinSelected(event.target.value) }}
                                        min={fechaInicioEtapa}
                                        max={fechaFinEtapa}
                                    ></Form.Control>
                                </td>
                            </tr>
                            <tr>
                                <td>Estatus</td>
                                <td>
                                    <Form.Select 
                                        value={estatusSelected}
                                        onChange={(event)=>{setEstatusSelected(event.target.value)}}
                                    >
                                        <option key={'opt_proyecto_estatus1'} value="No iniciado">No iniciado</option>
                                        <option key={'opt_proyecto_estatus2'} value="En proceso">En proceso</option>
                                        <option key={'opt_proyecto_estatus3'} value="En pausa">En pausa</option>
                                        <option key={'opt_proyecto_estatus4'} value="Completado">Completado</option>
                                        <option key={'opt_proyecto_estatus5'} value="Cancelado">Cancelado</option>
                                    </Form.Select>
                                </td>
                            </tr>
                            <tr>
                                <td>Usuario Responsable</td>
                                <td>
                                    <Form.Select
                                        value={idUsuarioResponsableSelected}
                                        onChange={(event)=>{
                                            setIdUsuarioResponsableSelected(event.target.value)
                                        }}
                                    >
                                        <option key="">--- Escoge un responsable ---</option>
                                        {
                                            usuarios.map(usuario=>
                                                <option 
                                                    key={'opt_usuario'+usuario.IDUSUARIO} 
                                                    value={usuario.IDUSUARIO}
                                                >
                                                    {usuario.NOMBREUSUARIO} [{usuario.PUESTO}]
                                                </option>
                                            )
                                        }
                                    </Form.Select>
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Close
                    </Button>
                    <Button 
                        variant="success" 
                        onClick={guardarTarea}
                    >
                        Actualizar tarea
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* 
                Modal para confirmar eliminación de etapa
            */}
            <Modal show={showModalEliminar} onHide={handleCloseModalEliminar} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        ¿Está seguro de eliminar la tarea?
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table striped hover responsive size="sm" style={{fontSize: '1em'}}>
                        <tbody>
                            <tr>
                                <td width="50%">idTarea</td>
                                <td width="50%">{idTareaSelected}</td>
                            </tr>
                            <tr>
                                <td>Etapa</td>
                                <td>{nombreEtapaSelected}</td>
                            </tr>
                            <tr>
                                <td>Nombre etapa (Descripción)</td>
                                <td>{descripcionSelected}</td>
                            </tr>
                            <tr>
                                <td>Fecha inicio</td>
                                <td>{inicioSelected}</td>
                            </tr>
                            <tr>
                                <td>Fecha fin</td>
                                <td>{finSelected}</td>
                            </tr>
                            <tr>
                                <td>Estatus</td>
                                <td>{estatusSelected}</td>
                            </tr>
                            <tr>
                                <td>Usuario Responsable</td>
                                <td>{nombreUsuarioResponsableSelected}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModalEliminar}>
                        Close
                    </Button>
                    <Button 
                        variant="danger" 
                        onClick={eliminaTarea}
                    >
                        Eliminar etapa
                    </Button>
                </Modal.Footer>
            </Modal>
            <h3 style={{textAlign: 'center'}}>ADMINISTRACIÓN DE TAREAS</h3>
            <Container>
                <Row style={{paddingTop: '1em', alignItems: 'right'}} className="justify-content-md-center">
                    <Col>
                        Agregar tarea <i onClick={()=>{
                            handleShowModal(-1, 0, 0, '', dateFechaActual, dateFechaActual, 'Activo', 0)
                        }} className="btn btn-success btn-sm bi bi-plus-square"></i>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <DataTable
                            columns={columns}
                            data={tareas}  
                            className="display"
                            options={options}
                            responsive={true}
                            slots={{
                                10: (data, row) => (
                                    <div>
                                        {/* 
                                            **** Ver detalle tarea
                                        */}
                                        <OverlayTrigger
                                            placement='top'
                                            overlay={
                                                <Tooltip>
                                                    <strong>Ver detalle </strong> tarea.
                                                </Tooltip>
                                            }
                                        >
                                            
                                            <Button 
                                                className="btn-default btn-sm bi bi-search"
                                                style={{marginRight: '1em'}}
                                                onClick={
                                                    () => {
                                                        handleShowModalDetalle(row.IDTAREA, row.NOMBREETAPA, row.DESCRIPCION, row.INICIO, row.FIN, 
                                                        row.ESTATUS, row.NOMBREUSUARIORESPONSABLE)
                                                    }
                                                }
                                            >
                                            </Button>
                                        </OverlayTrigger>
                                        {/* 
                                            **** Editar tarea
                                        */}
                                        <OverlayTrigger
                                            placement='top'
                                            overlay={
                                                <Tooltip>
                                                    <strong>Editar </strong> tarea.
                                                </Tooltip>
                                            }
                                        >
                                            <Button 
                                                className="btn-warning btn-sm bi bi-pencil-square"
                                                style={{marginRight: '1em'}}
                                                onClick={
                                                    () => {
                                                        handleShowModal(row.IDTAREA, row.IDETAPA, row.IDPROYECTO, row.DESCRIPCION, row.INICIO, row.FIN, 
                                                        row.ESTATUS, row.IDUSUARIORESPONSABLE)
                                                    }
                                                }
                                            >
                                            </Button>
                                        </OverlayTrigger>
                                        {/* 
                                            **** Eliminar tarea
                                        */}
                                        <OverlayTrigger
                                            placement='top'
                                            overlay={
                                                <Tooltip>
                                                    <strong>Eliminar</strong> etapa.
                                                </Tooltip>
                                            }
                                        >
                                            <Button 
                                                className="btn-danger btn-sm bi bi-x-square-fill"
                                                style={{marginRight: '1em'}}
                                                onClick={
                                                    () => {
                                                        handleShowModalEliminar(row.IDTAREA, row.NOMBREETAPA, row.DESCRIPCION, row.INICIO, row.FIN, 
                                                        row.ESTATUS, row.NOMBREUSUARIORESPONSABLE)
                                                    }
                                                }
                                            >
                                            </Button>
                                        </OverlayTrigger>
                                    </div>
                                )
                            }}
                        >
                            <thead>
                                <tr>
                                    <th className="dt-orderable-asc">IDTAREA</th>
                                    <th>IDETAPA</th>
                                    <th>ETAPA</th>
                                    <th>IDPROYECTO</th>
                                    <th>DESCRIPCION</th>
                                    <th>FECHAINICIO</th>
                                    <th>FECHAFIN</th>
                                    <th>ESTATUS</th>
                                    <th>IDUSUARIO</th>
                                    <th>ENCARGADO</th>
                                </tr>
                            </thead>
                        </DataTable>
                    </Col>
                </Row>    
            </Container>
        </div>
    )
}

export default TareasCRUD